import axios from 'axios';

// String vazia → URLs relativas roteadas pelo nginx (/api/... → http://api:3000)
// String com valor → URL absoluta (ex: http://localhost:3000 em dev direto)
const API_URL = process.env.REACT_APP_API_URL ?? '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Injeta o Bearer token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth-token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// ─── Camadas ──────────────────────────────────────────────────────────────────
export const layersAPI = {
  getAll:        () => api.get('/api/layers'),
  getById:       (layerId) => api.get(`/api/layers/${layerId}`),
  getAttributes: (layerId) => api.get(`/api/layers/${layerId}/attributes`)
};

// ─── Filtros ──────────────────────────────────────────────────────────────────
export const filtersAPI = {
  spatial:    (data) => api.post('/api/filters/spatial', data),
  attributes: (data) => api.post('/api/filters/attributes', data),
  temporal:   (data) => api.post('/api/filters/temporal', data),
  combined:   (data) => api.post('/api/filters/combined', data)
};

// ─── Exportações ──────────────────────────────────────────────────────────────
export const exportsAPI = {
  export: (format, data) => api.post(`/api/export/${format}`, data, { responseType: 'blob' })
};

// ─── Autenticação ─────────────────────────────────────────────────────────────
export const authAPI = {
  login:           (email, password) => api.post('/api/auth/login', { email, password }),
  requestRegister: (data)            => api.post('/api/auth/register-request', data),
  me:              ()                => api.get('/api/auth/me'),
  logout:          ()                => api.post('/api/auth/logout'),
};

// ─── Admin (usuários) ─────────────────────────────────────────────────────────
export const adminAPI = {
  listUsers:      (page = 1, limit = 20) => api.get('/api/admin/users', { params: { page, limit } }),
  getUser:        (id)                   => api.get(`/api/admin/users/${id}`),
  createUser:     (data)                 => api.post('/api/admin/users', data),
  updateUser:     (id, data)             => api.put(`/api/admin/users/${id}`, data),
  deactivateUser: (id)                   => api.patch(`/api/admin/users/${id}/deactivate`),
  activateUser:   (id)                   => api.patch(`/api/admin/users/${id}/activate`),
};

// ─── Catálogo de Camadas ──────────────────────────────────────────────────────
export const catalogAPI = {
  getTree:        ()         => api.get('/api/catalog'),
  getAvailableLayers: (municipalityCode) =>
    api.get('/api/catalog/available-layers', { params: { municipalityCode } }),
  getPending:     ()         => api.get('/api/catalog/pending'),
  createGroup:    (data)     => api.post('/api/catalog/groups', data),
  updateGroup:    (id, data) => api.put(`/api/catalog/groups/${id}`, data),
  deleteGroup:    (id)       => api.delete(`/api/catalog/groups/${id}`),
  createCategory: (data)     => api.post('/api/catalog/categories', data),
  updateCategory: (id, data) => api.put(`/api/catalog/categories/${id}`, data),
  deleteCategory: (id)       => api.delete(`/api/catalog/categories/${id}`),
  createFolder:   (data)     => api.post('/api/catalog/folders', data),
  updateFolder:   (id, data) => api.put(`/api/catalog/folders/${id}`, data),
  deleteFolder:   (id)       => api.delete(`/api/catalog/folders/${id}`),
  assign:         (data)     => api.post('/api/catalog/assignments', data),
  unassign:       (id)       => api.delete(`/api/catalog/assignments/${id}`),
};

export default api;
